import script from "./contact-details.vue?vue&type=script&setup=true&lang=js"
export * from "./contact-details.vue?vue&type=script&setup=true&lang=js"

import "./contact-details.vue?vue&type=style&index=0&id=566e5f5b&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-566e5f5b"]])

export default __exports__